import { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

type LayoutContextType = {
  gridTemplate: string
  setGridTemplate: (template: string) => void
  contentBorderRadius: string
  setContentBorderRadius: (radius: string) => void
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider = ({ children }: { children: ReactNode }) => {
  const [gridTemplate, setGridTemplate] = useState('32rem minmax(30rem,68rem) 32rem')
  const [contentBorderRadius, setContentBorderRadius] = useState('2.5rem 2.5rem 0 0')

  return (
    <LayoutContext.Provider
      value={{
        gridTemplate,
        setGridTemplate,
        contentBorderRadius,
        setContentBorderRadius,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export const useLayoutContext = () => {
  const ctx = useContext(LayoutContext);
  if (!ctx) throw new Error("useLayoutContext must be used within a LayoutProvider");
  return ctx;
};
